// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1or75","ranges":"BmiRanges_ranges__1A_Tg"};